import { FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { IFilteringViewModel } from "../../_common/interface/table";
import { PrimaryButton } from "../../_components/button/primary.button";
import StyledGrid from "../../_components/grid/styledGrid";
import { CommonTable } from "../../_components/table/common.table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { databaseService } from "../../_services/database.service";
import { getDate, getDateString } from "../../_helpers/dateTime.helper";


export function UserProfileInsuranceDatabaseList(params: {}) {

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const { userId } = useParams<{ userId: string }>();

    const [filter, setFilter] = useState<IFilteringViewModel | null>(null);

    const [search, setSearch] = useState({
        userName: '',
        email: '',
        fromDate: '',
        toDate: '',
        formTemplateTypeId: ''
    });

    let navigate = useNavigate();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'id',
                header: 'Id',
            },
            {
                accessorKey: 'userName',
                header: 'User Name',
            },
            {
                accessorKey: 'role',
                header: 'Role',
                accessorFn: (rowData: any) => <>
                    {rowData.isOfficial ? "Official" : "Competitor"}
                </>,
            },
            // {
            //     accessorKey: 'licenseNumber',
            //     header: 'Licence Number',
            //     accessorFn: (rowData: any) => <>
            //         {rowData.irdsExpiryDate ? " IRDS: " + rowData.irdsLicenseNumber : ""}<br/>
            //         {rowData.brdsExpiryDate ? " BRDS: " + rowData.brdsPrefix + " " + rowData.brdsLicenseNumber : ""}
            //     </>,
            // },
            {
                accessorKey: 'expiryDate',
                header: 'Expiry Date',
                accessorFn: (rowData: any) => <>
                    {rowData.irdsExpiryDate ? " IRDS: " + getDate(rowData.irdsExpiryDate) : ""}<br />
                    {rowData.brdsExpiryDate ? " BRDS: " + getDate(rowData.brdsExpiryDate) : ""}
                </>,
            }
        ],
        [],
    );

    useEffect(() => {
        if (filter)
            fetchData();
    }, [filter]);

    function fetchData() {

        return databaseService.getAll({ ...filter, ...search })
            .then(
                data => {
                    console.log(data);
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function handleChange(event: any) {
        setSearch((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    return (
        <>

            <Grid container direction="row" justifyContent="space-between" mb={4} spacing={1}>
                <Grid item xs={6} >
                    <Typography variant="h5" color="primary">Insurance</Typography>
                </Grid>

            </Grid>

            <Paper>
                <ValidatorForm onSubmit={fetchData}>
                    <StyledGrid container spacing={2}>
                        <Grid item lg={2} md={6} xs={12}>
                            <FormControl fullWidth>
                                <TextField label="User Name" name="userName" value={search.userName} onChange={handleChange} placeholder="User Name" variant="outlined" />
                            </FormControl>
                        </Grid>

                        <Grid item lg={2} md={6} xs={12}>
                            <FormControl fullWidth>
                                <InputLabel>Insurance Type</InputLabel>
                                <Select
                                    label="Insurance Type"
                                    name="formTemplateTypeId"
                                    value={search.formTemplateTypeId}
                                    placeholder="Insurance Type"
                                    onChange={handleChange}
                                    variant="outlined">
                                    <MenuItem value={''}>Any</MenuItem>
                                    <MenuItem value={FormTemplateTypeEnum.BRDS}>BRDS</MenuItem>
                                    <MenuItem value={FormTemplateTypeEnum.IRDS}>IRDS</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item lg={2} md={6} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    type="date"
                                    label="From Date"
                                    name="fromDate"
                                    value={search.fromDate}
                                    onChange={handleChange}
                                    placeholder="From Date"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item lg={2} md={6} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    type="date"
                                    label="To Date"
                                    name="toDate"
                                    value={search.toDate}
                                    onChange={handleChange}
                                    placeholder="To Date"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item lg={2} md={6} xs={12}>
                            <PrimaryButton
                                fullHeight
                                isLoading={isLoading}
                                type="submit"
                                variant="save">{"Search"}
                            </PrimaryButton>
                        </Grid>
                    </StyledGrid>
                </ValidatorForm>

                <CommonTable
                    columns={columns}
                    data={data}
                    setFilter={setFilter}
                    isLoading={isLoading}
                />
            </Paper>
        </>
    );
}